














































































































































































































































































































































import zoneData from '@/helpers/offers/zones';
import LabelLanes from '@/components/common/offers/laneLabel.vue';
import {
    trailerType,
    offerCurrencies,
    offerResult,
    zone,
} from '@/helpers/offers/reparto';
import {
    ADD_LANES,
    DELETE_LANE,
    laneFormData,
} from '@/store/modules/offersModule';
import eventbus, { EVENTS_TYPE } from '@/services/eventbus';

export default {
    props: ['laneData', 'laneIndex'],

    components: {
        LabelLanes,
    },
    data(this: any) {
        return {
            trailerType,
            offerCurrencies,
            offerResult,
            zoneData,
            options: [],
            loading: false,
            lanesForm: laneFormData,
            rules: {
                trailerType: [
                    {
                        required: true,
                        message: this.$t('offer.pls_entr_name'),
                        trigger: 'blur',
                    },
                ],
                trips: [
                    {
                        required: true,
                        message: this.$t('offer.pls_entr_name'),
                        trigger: 'blur',
                    },
                ],
                price: [
                    {
                        required: true,
                        message: this.$t('offer.pls_entr_name'),
                        trigger: 'blur',
                    },
                ],
                zone: [
                    {
                        required: true,
                        message: this.$t('offer.select'),
                        trigger: 'change',
                    },
                ],
                zip: [
                    {
                        required: true,
                        message: this.$t('offer.pls_entr_name'),
                        trigger: 'blur',
                    },
                ],
                city: [
                    {
                        required: true,
                        message: this.$t('offer.pls_entr_name'),
                        trigger: 'blur',
                    },
                ],
                currency: [
                    {
                        required: true,
                        message: this.$t('offer.select'),
                        trigger: 'change',
                    },
                ],
                dateArray: [
                    {
                        required: true,
                        message: this.$t('offer.select'),
                        trigger: 'change',
                    },
                ],
            },
        };
    },

    methods: {
        cancelForm(this: any, index: number) {
            if (this.lanesForm.isNew) {
                this.deleteLane(index);
            } else {
                this.lanesForm = {
                    ...this.lanesForm,
                    ...{ isNew: false, isEditing: false },
                };
            }
        },
        checkField(this: any, value: any) {
            this.$refs.lanesForm.validate((valid: any) => valid);
        },
        saveForm(this: any, value: number) {
            this.$refs.lanesForm.validate((valid: any) => {
                if (!valid) {
                    return false;
                }

                this.lanesForm = {
                    ...this.lanesForm,
                    ...{ isNew: false, isEditing: false },
                };
                const payload = {
                    index: this.laneIndex,
                    lane: this.lanesForm,
                };
                if (value === 1) {
                    payload.lane = {
                        ...this.lanesForm,
                        dateFrom: this.lanesForm.dateArray[0],
                        dateTo: this.lanesForm.dateArray[1],
                    };
                }
                this.$store.commit('UPDATE_LANE', payload);
                return true;
            });
        },

        addLoads(this: any, val: number) {
            if (val === 1) {
                this.lanesForm.collections.push({ ...zone });
            } else {
                this.lanesForm.deliveries.push({ ...zone });
            }
        },
        removeLoads(this: any, val: number, index: number) {
            if (val === 1) {
                this.lanesForm.collections.splice(index, 1);
            } else {
                this.lanesForm.deliveries.splice(index, 1);
            }
        },

        fromZone(this: any, query: string) {
            if (query !== '') {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.options = this.zoneData.filter(
                        (item: any) => item.ZONE.toLowerCase().indexOf(query.toLowerCase()) > -1,
                    );
                }, 200);
            } else {
                this.options = [];
            }
        },
        fromZoneVal(this: any, value: any, ind: number) {
            this.lanesForm.collections[ind].zone = value.ZONE;
            this.lanesForm.collections[ind].country = value.COUNTRY;
        },

        toZoneVal(this: any, value: any, ind: number) {
            this.lanesForm.deliveries[ind].zone = value.ZONE;
            this.lanesForm.deliveries[ind].country = value.COUNTRY;
        },
        updateLaneData(this: any) {
            if (!(Object.keys(this.laneData).length === 0)) {
                this.lanesForm = JSON.parse(JSON.stringify(this.laneData));
            }
        },
        confirmDeleteLane(this: any, index: number) {
            this.$confirm(
                this.$t('offer.removeLane'),
                this.$t('offer.alert_warning'),
                {
                    confirmButtonText: this.$t('offer.confirm_yes'),
                    cancelButtonText: this.$t('offer.confirm_no'),
                    type: 'warning',
                },
            ).then(() => {
                this.deleteLane(index);
            });
        },
        deleteLane(this: any, index: number) {
            this.$store.commit(DELETE_LANE, index);
        },
        cloneLane(this: any) {
            const newLane = {
                ...this.lanesForm,
                ...{ isNew: true, isEditing: false, _id: null },
            };
            this.$store.commit(ADD_LANES, newLane);
        },
        editLane(this: any) {
            this.lanesForm.isEditing = true;
        },
        changeResult(this: any) {
            if (this.lanesForm.result === 'Accepted') {
                this.lanesForm.feedback = '';
            }
        },
    },

    computed: {
        pickerOptions(this: any) {
            return {
                firstDayOfWeek: 1,
            };
        },
        disableFields(this: any) {
            return !(this.lanesForm.isEditing || this.lanesForm.isNew);
        },
    },
    watch: {
        laneData(this: any) {
            this.updateLaneData();
        },
    },
    mounted(this: any) {
        eventbus.$on(EVENTS_TYPE.VALID_TYPE, this.checkField);
        this.updateLaneData();
    },
};
